export const containerSX = {
  border: "1px solid #E0E0E0",
  borderRadius: "14px",
  padding: "18px",
  backgroundColor: "#FAFAFA",
};

export const progressBarSX = {
  display: "flex",
  gap: 1,
  mb: 2,
};

export const progressItemSX = (completed) => ({
  flex: 1,
  height: "5px",
  borderRadius: "4px",
  backgroundColor: completed ? "#75d846" : "#E0E0E0",
  transition: "0.3s",
});

export const stepBoxSX = (borderColor, bgColor = "#FFFFFF") => ({
  border: "2px solid",
  borderColor,
  borderRadius: "10px",
  padding: "12px",
  backgroundColor: bgColor,
  position: "relative",
});

export const overlaySX = {
  position: "absolute",
  inset: 0,
  background: "rgba(255,255,255,0.7)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "10px",
  fontSize: "12px",
  color: "#888",
  zIndex: 1,
};
